// UPI apps (PhonePe, Google Pay, Paytm…) on Razorpay's checkout in the apps.
//
// Inside an app's WebView, Razorpay's checkout lists UPI apps only when the page
// asks for them (webview_intent). Without it the checkout has no UPI at all:
// paying by UPI ID (UPI Collect) was withdrawn on 28 Feb 2026, so the UPI apps
// were all that was left — only cards and net banking show.
// Asking is only right where the app can open the UPI app the customer picks,
// from the link Razorpay opens (phonepe://pay?…, upi://pay?…):
//   - Android: Capacitor hands every link it can't load itself to Android, which
//     opens the app.
//   - iPhone: only apps built with the UpiIntent native plugin
//     (scripts/build_app.py); older iPhone apps keep today's checkout until updated.
// Browsers aren't WebViews (Razorpay decides there itself), so nothing is asked.

export const canOpenUpiApps = () => {
  const capacitor = window.Capacitor;
  if (!capacitor?.isNativePlatform?.()) return false;
  return capacitor.getPlatform?.() === 'android' || Boolean(capacitor.isPluginAvailable?.('UpiIntent'));
};

// Spread into Razorpay's checkout options.
export const upiAppOptions = () => (canOpenUpiApps() ? { webview_intent: true } : {});
